import createOpenapiClient, {} from "openapi-fetch";
/**
 * Build a typed client for the Postbag `/v1` API. This is the only way the dashboard,
 * CLI, MCP server and any agent script talk to Postbag — nothing bypasses `/v1`.
 */
export function createClient(options) {
    const client = createOpenapiClient({
        baseUrl: options.baseUrl,
        credentials: options.credentials ?? "include",
        ...(options.fetch === undefined ? {} : { fetch: options.fetch }),
    });
    if (options.apiKey !== undefined) {
        const auth = {
            onRequest({ request }) {
                request.headers.set("Authorization", `Bearer ${options.apiKey}`);
                return request;
            },
        };
        client.use(auth);
    }
    return client;
}
//# sourceMappingURL=client.js.map